import React from "react";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className="text-2xl font-semibold text-cpurple">
                    <Emoji
                        symbol="💻"
                        label="masterclass online mossos ambit b"
                    />{" "}
                    MASTERCLASS ONLINE MOSSOS D&apos;ESQUADRA — ÀMBIT B
                    (23/09/2026)
                </h2>

                <p className="mt-5">
                    <strong>
                        Domina els conceptes clau de l&apos;Àmbit B en una única
                        sessió intensiva.
                    </strong>
                </p>

                <p className="mt-5">
                    L&apos;Àmbit B <strong>(àmbit institucional)</strong> és una
                    de les parts més importants del temari de Mossos
                    d&apos;Esquadra. Comprendre l&apos;organització política, el
                    marc jurídic i les institucions és fonamental per afrontar
                    la prova de coneixements amb garanties.
                </p>

                <p className="mt-5">
                    Per això, a iOpos hem preparat una{" "}
                    <strong>Masterclass Online de 4 hores</strong>, on
                    treballarem els conceptes essencials d&apos;aquest àmbit
                    perquè puguis consolidar coneixements, resoldre dubtes i
                    arribar a l&apos;examen amb més seguretat.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="preparat amb criteri" />{" "}
                    Prepara&apos;t amb criteri
                </h2>

                <p className="mt-5">
                    Aquesta formació està pensada perquè puguis:
                </p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        Reforçar els conceptes més importants de l&apos;Àmbit B.
                    </li>
                    <li>
                        Entendre els continguts que acostumen a generar més
                        dificultats.
                    </li>
                    <li>
                        Identificar els aspectes més preguntables de
                        l&apos;examen.
                    </li>
                    <li>Consolidar coneixements abans de la prova oficial.</li>
                </ul>

                <p className="mt-5">
                    Una sessió intensiva perquè{" "}
                    <strong>
                        aprofitis al màxim el teu temps d&apos;estudi
                    </strong>{" "}
                    i et centris en allò que realment marca la diferència.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📚" label="que inclou la masterclass" /> Què
                    inclou la Masterclass?
                </h2>

                <p className="mt-5">
                    Durant la sessió treballarem els continguts principals de
                    l&apos;Àmbit B amb una explicació{" "}
                    <strong>clara, estructurada i orientada a examen</strong>.
                </p>

                <p className="mt-5">La formació inclou:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Explicacions en directe amb la docent.</li>
                    <li>Resolució de dubtes.</li>
                    <li>Repàs dels conceptes clau.</li>
                    <li>Accés a la gravació completa de la sessió.</li>
                    <li>
                        Possibilitat de revisar-la tantes vegades com necessitis
                        fins al dia de l&apos;examen.
                    </li>
                </ul>

                <p className="mt-5">
                    Tot perquè puguis preparar aquest àmbit amb{" "}
                    <strong>les màximes garanties</strong>.
                </p>

                {/*<h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="👩‍🏫" label="professorat masterclass" />{" "}
                    Professorat
                </h2>

                <p className="mt-5">
                    La formació serà impartida per <strong>Laia</strong>, una de
                    les docents més reconegudes i valorades d&apos;iOpos
                    Acadèmia, especialista en la preparació de Mossos
                    d&apos;Esquadra.
                </p>*/}

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💻" label="modalitat masterclass online" />{" "}
                    Modalitat
                </h2>

                <p className="mt-5">
                    La Masterclass es realitzarà{" "}
                    <strong>100% online i en directe</strong> a través de Zoom.
                </p>

                <p className="mt-5">
                    El mateix dia de la sessió trobaràs l&apos;enllaç
                    d&apos;accés disponible al teu campus virtual.
                </p>

                <p className="mt-5">
                    Si no pots assistir en directe, no et preocupis: la classe
                    quedarà gravada perquè la puguis visualitzar posteriorment{" "}
                    <strong>
                        tantes vegades com necessitis fins al dia de
                        l&apos;examen
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="📅" label="data i horari masterclass" /> Data
                    i horari
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong>23 de setembre de 2026 (dimecres).</strong>
                    </li>
                    <li>
                        De <strong>18.00 a 22.00 h</strong>.
                    </li>
                    <li>
                        Durada: <strong>4 hores</strong>.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="💰" label="preu masterclass" /> Preu
                </h2>

                <p className="mt-5">
                    <strong>49,99 €</strong>
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="resum masterclass ambit b" /> En
                    resum
                </h2>

                <p className="mt-5">
                    Una Masterclass intensiva perquè puguis dominar els
                    conceptes més importants de l&apos;Àmbit B, reforçar el teu
                    estudi i arribar a l&apos;examen de Mossos d&apos;Esquadra
                    amb més confiança.
                </p>

                <p className="mt-5">
                    <Emoji symbol="👉" label="masterclass orientada a exit" />{" "}
                    Una única sessió que et permetrà repassar tot l&apos;Àmbit B
                    de manera{" "}
                    <strong>clara, pràctica i orientada a l&apos;èxit</strong>.
                </p>
            </section>
        );
    };

    return (
        <NewProductTemplate
            item={item}
            title="Converteix un dels àmbits més densos del temari en un dels teus punts forts."
        >
            <Data />
        </NewProductTemplate>
    );
};

export default Product;
